import { z } from 'zod';
import { fontSizeSchema, coordinateSchema, sizeSchema } from '../../../Shared.js';

const baseCellSchema = z.object({
  id: z.string(),
  style: z.object({
    background: z.object({
      color: z.string(),
      opacity: z.number().optional()
    }),
    font: z.object({
      color: z.string().optional(),
      size: fontSizeSchema.optional()
    }).optional()
  }).default({ background: { color: "#fff" } })
});
const tableItemTextCellSchema = baseCellSchema.extend({
  kind: z.literal("text"),
  content: z.string().default("")
});
const tableItemInputCellSchema = baseCellSchema.extend({
  kind: z.literal("input"),
  placeholder: z.string().default("")
});
const tableItemSchema = z.object({
  kind: z.literal("table"),
  id: z.string(),
  position: coordinateSchema,
  size: sizeSchema,
  rowHeight: z.array(z.number()),
  columnWidth: z.array(z.number()),
  cells: z.array(
    z.array(
      z.discriminatedUnion("kind", [
        tableItemTextCellSchema,
        tableItemInputCellSchema
      ])
    )
  ).default([]),
  font: z.object({
    color: z.string().optional(),
    size: fontSizeSchema
  })
});

export { tableItemSchema };
//# sourceMappingURL=Table.js.map
